const imageWrappers = document.querySelectorAll(
	'.block-content-before-after-image__image-wrapper'
);

imageWrappers.forEach((imageWrapper) => {
	const range = imageWrapper.querySelector(
		'.block-content-before-after-image__slider'
	);

	// Update slider value visually
	function updateSlider(val) {
		imageWrapper.style.setProperty('--progress', `${val}%`);
		range.setAttribute('aria-valuenow', val);
	}
	updateSlider(range.value);

	range.addEventListener('input', () => {
		updateSlider(range.value);
	});

	// Click anywhere on image to move slider
	function setSliderFromEvent(e) {
		const rect = imageWrapper.getBoundingClientRect();
		let x;
		if (e.type.startsWith('touch')) {
			x = e.touches[0].clientX - rect.left;
		} else {
			x = e.clientX - rect.left;
		}
		const percent = Math.round((x / rect.width) * 100);
		const clamped = Math.max(0, Math.min(100, percent));
		range.value = clamped;
		updateSlider(clamped);
		range.focus();
	}

	let isDragging = false;

	imageWrapper.addEventListener('mousedown', (e) => {
		if (e.button !== 0) return;
		isDragging = true;
		setSliderFromEvent(e);
	});

	imageWrapper.addEventListener('mousemove', (e) => {
		if (!isDragging) return;
		setSliderFromEvent(e);
	});

	document.addEventListener('mouseup', () => {
		isDragging = false;
	});

	// Touch support for mobile
	imageWrapper.addEventListener('touchstart', (e) => {
		isDragging = true;
		setSliderFromEvent(e);
	});
	imageWrapper.addEventListener('touchmove', (e) => {
		if (!isDragging) return;
		setSliderFromEvent(e);
	});
	document.addEventListener('touchend', () => {
		isDragging = false;
	});

	// Keyboard accessibility: left/right arrows
	range.addEventListener('keydown', (e) => {
		let val = parseInt(range.value, 10);
		if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
			val = Math.max(val - 1, parseInt(range.min, 10));
			range.value = val;
			updateSlider(val);
			e.preventDefault();
		} else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
			val = Math.min(val + 1, parseInt(range.max, 10));
			range.value = val;
			updateSlider(val);
			e.preventDefault();
		}
	});
});
